import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, AppConfig } from '../app-config';
import { IIntegrationRepository } from './Iintegration.repository';
import { ApiResponse, CloneCase, ImageCategorization, MigratePlan, SendCase, StrutEvent } from './models';


@Injectable({ providedIn: 'root' })
export class IntegrationRepository implements IIntegrationRepository {

	constructor(private readonly httpClient: HttpClient, @Inject(APP_CONFIG) private readonly config: AppConfig) { }


	sendCase(id: string, sendCase: SendCase): Observable<ApiResponse<void>> {
		return this.httpClient.post<ApiResponse<void>>(this.config.domainIntegrationAPI + `/api/integration/sendcase/${id}`, sendCase);
	}

	cloneSendCase(cloneCase: CloneCase): Observable<ApiResponse<void>> {
		return this.httpClient.post<ApiResponse<void>>(this.config.domainIntegrationAPI + '/api/integration/clonesendcase', cloneCase);
	}

	createPostopPlan(caseId: string, userId: string): Observable<ApiResponse<string>> {
		return this.httpClient.post<ApiResponse<string>>(this.config.domainIntegrationAPI + `/api/integration/preop2postop?caseId=${caseId}&userId=${userId}`, null);
	}

	migratePlan(id: string, migratePlan: MigratePlan): Observable<ApiResponse<void>> {
		return this.httpClient.post<ApiResponse<void>>(this.config.domainIntegrationAPI + `/api/integration/migratecase/${id}`, migratePlan);
	}

	editImageCategorization(id: string, imageData: ImageCategorization): Observable<ApiResponse<any>> {
		return this.httpClient.patch<ApiResponse<any>>(this.config.domainIntegrationAPI + `/api/integration/editcategorization/${id}`, imageData);
	}

	getStrutsEvents(from: Date, to: Date, patientList?: string[]): Observable<ApiResponse<StrutEvent[]>> {
		let params = new HttpParams().set('from', from.toDateString()).set('to', to.toDateString());
		return this.httpClient.post<ApiResponse<StrutEvent[]>>(this.config.domainIntegrationAPI + `/api/treatment/StrutsEvents`, patientList, { params });
	}
}
